import { Entity } from '../entity';
import { JobDateSort } from '../job/job';
import { Address } from '../shared/address';
import { Attachment } from '../shared/attachment';
import { Site } from '../shared/site';
import { LeadAccount } from './lead.account';
import { LeadContact } from './lead.contact';
import { LeadSystemStage } from './lead.stage';

export interface Lead extends Entity {

    stage: LeadSystemStage;

    account: LeadAccount;
    contact: LeadContact;
    address: Address;

    description: string;
    amount: number;
    expectedClose: Date;
    lastActivity: Date;

    source: Entity;
    owner: Entity;
    company: Entity;
    jobType?: Entity;

    attachments: Attachment[];

    customFields: any;

    tags?: Entity[];
    zones?: Entity[];
    timezone?: string;
    stageUpdatedAt?: Date;

    createdAt?: Date;
    updatedAt?: Date;

    sorting?: {
        lastActivity: JobDateSort
    }

}

export enum LeadCommandId {
    UpdateStage = 'UpdateStage',
    Delete = 'Delete',
    ConvertLead = 'ConvertLead',
}